import compact from "lodash/compact";
import ProgressBar from "PFCore/components/progress_bar/progress_bar";
import PropTypes from "prop-types";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./engagement.less";

const EngagementProgressBar = ({ statusTally, total }) => {
  const { t } = useTranslation("auditPlanner");
  const { filled, exception, pending, auto_shortlisting, auto_filling, shortlisting, booked, confirmed } =
    statusTally;

  const pendingCount = (pending || 0) + (auto_shortlisting || 0) + (auto_filling || 0);

  const getProgressFill = useCallback(
    (value, text, color) =>
      value && {
        text,
        value,
        color,
        tooltipContent: `${value}/${total} ${text}`
      },
    [total]
  );

  const progressBars = useMemo(
    () =>
      compact([
        getProgressFill(confirmed, t("progressBar.confirmed"), "var(--WorkflowState-confirmed)"),
        getProgressFill(booked, t("progressBar.booked"), "var(--WorkflowState-booked)"),
        getProgressFill(filled, t("progressBar.filled"), "var(--WorkflowState-filled)"),
        getProgressFill(exception, t("progressBar.exception"), "var(--WorkflowState-exception)"),
        getProgressFill(shortlisting, t("progressBar.notFilled"), "var(--Palette-alert)"),
        getProgressFill(pendingCount, t("progressBar.pending"), "var(--Palette-neutral-mid)")
      ]),
    [booked, filled, exception, pendingCount, confirmed, shortlisting, total]
  );

  if (!total) {
    return null;
  }

  return (
    <div className={css.progressBar}>
      <ProgressBar values={progressBars} />
    </div>
  );
};

EngagementProgressBar.propTypes = {
  statusTally: PropTypes.shape({
    filled: PropTypes.number,
    exception: PropTypes.number,
    pending: PropTypes.number,
    auto_shortlisting: PropTypes.number,
    auto_filling: PropTypes.number,
    shortlisting: PropTypes.number,
    booked: PropTypes.number,
    confirmed: PropTypes.number
  }).isRequired,
  total: PropTypes.number.isRequired
};

export default EngagementProgressBar;
